import React from "react";
import PropTypes from "prop-types";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

/**
 * InfoRow - A reusable component to display labeled information
 * @param {Object} props
 * @param {React.ReactNode} props.icon - Icon component
 * @param {string} props.label - Label text
 * @param {React.ReactNode} props.value - Value to display
 * @param {string} props.iconColor - Icon color
 * @param {boolean} props.white - Use white text color
 */
const InfoRow = ({ icon: Icon, label, value, iconColor = "#667eea", white = false }) => {
  return (
    <ArgonBox mb={2}>
      <ArgonBox display="flex" alignItems="center" gap={1} mb={1}>
        {Icon && (
          <ArgonBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 36,
              height: 36,
              borderRadius: "10px",
              backgroundColor: white ? "rgba(255, 255, 255, 0.15)" : "rgba(102, 126, 234, 0.1)",
              backdropFilter: "blur(10px)",
            }}
          >
            <Icon sx={{ fontSize: 20, color: white ? "#fff" : iconColor }} />
          </ArgonBox>
        )}
        <ArgonTypography
          variant="caption"
          fontWeight="bold"
          sx={{
            color: white ? "rgba(255, 255, 255, 0.9)" : "#64748b",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            fontSize: "0.75rem",
          }}
        >
          {label}
        </ArgonTypography>
      </ArgonBox>
      <ArgonTypography
        variant="body2"
        sx={{
          color: white ? "#fff" : "#334155",
          fontWeight: white ? 600 : 500,
          fontSize: "0.938rem",
          ml: 5,
          wordBreak: "break-word",
        }}
      >
        {value || "N/A"}
      </ArgonTypography>
    </ArgonBox>
  );
};

InfoRow.propTypes = {
  icon: PropTypes.elementType,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  iconColor: PropTypes.string,
  white: PropTypes.bool,
};

InfoRow.defaultProps = {
  icon: undefined,
  value: undefined,
  iconColor: "#667eea",
  white: false,
};

export default InfoRow;
